import React from 'react';
import { Link } from 'react-router-dom';
import Seo from './Seo';
import { Button } from './ui/button';
import { PhoneOff, ArrowRight } from 'lucide-react';

// Branded 404 with routes back into the site.
const NotFound = () => (
  <div className="min-h-screen pt-24 pb-16 flex items-center px-4 sm:px-6 lg:px-8">
    <Seo title="Page not found" description="The page you are looking for does not exist or has moved." noindex />
    <div className="max-w-2xl mx-auto text-center">
      <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-[#0a1f2e] mb-8">
        <PhoneOff className="w-10 h-10 text-[#c8ff00]" />
      </div>
      <div className="text-7xl font-bold text-[#0a1f2e] mb-4 font-display tabular-nums">404</div>
      <h1 className="text-3xl font-bold text-[#0a1f2e] mb-4">This number is not in service</h1>
      <p className="text-xl text-gray-600 mb-10">
        The page you are looking for doesn't exist or has moved.
        Try one of these instead:
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
        <Link to="/">
          <Button size="lg" style={{ backgroundColor: '#c8ff00', color: '#0a1f2e' }} className="font-semibold hover:opacity-90 w-full sm:w-auto">
            Back to home
          </Button>
        </Link>
        <Link to="/coverage">
          <Button size="lg" variant="outline" className="w-full sm:w-auto">
            Coverage & Pricing
          </Button>
        </Link>
      </div>
      <Link to="/contact" className="inline-flex items-center gap-2 text-[#0a1f2e] font-semibold hover:gap-3 transition-all">
        Or contact our team <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  </div>
);

export default NotFound;
